export default "__VITE_ASSET__CYC4zObp__"